import { MutationTree } from 'vuex';
import { ConfigState } from '../../models';
import { SetConfigMutation } from './mutations/set-config.mutation';
import { SetCurrencyMutation } from './mutations/set-currency.mutation';
import { SetDeviceMutation } from './mutations/set-device.mutation';
import { SetDynamicConfigMutation } from './mutations/set-dynamic-config.mutation';
import { SetLocaleMutation } from './mutations/set-locale.mutation';

export const CONFIG_MUTATIONS: MutationTree<ConfigState> = {
  ...new SetConfigMutation().mutations,
  ...new SetCurrencyMutation().mutations,
  ...new SetDeviceMutation().mutations,
  ...new SetLocaleMutation().mutations,
  ...new SetDynamicConfigMutation().mutations
};
